import { E2EProjectModel } from '../../../../shared/models/E2EProject.model'
import ProjectStatus from '../enums/project-status'
import PmrE2EProjectHandler from './pmr-e2e-project-handlers'
import { E2EProjectLineMilestoneGroupItemModel } from './pmr-e2e-project-milestone-group-item-model'
import { E2EProjectLineFlexTaskGroupItemModel } from './pmr-e2e-project-task-group-item-model'

export default interface PmrE2EProjectModel extends Omit<E2EProjectModel, 'status'> {
  status: ProjectStatus
  e2EProjectHandlers: PmrE2EProjectHandler[]
  isChecked: boolean
  isExpand: boolean
  createdByDisplayName?: string | null
  flexSoldTo?: string
  partySiteNumber?: string
  hasCompletedProjectLineFlexTaskStatus?: boolean
  hasCompletedProjectLine?: boolean
  myCreatedE2EProject?: boolean
  e2EProjectLineFlexTaskGroupItems: E2EProjectLineFlexTaskGroupItemModel[]
  e2EProjectLineMilestoneGroupItems: E2EProjectLineMilestoneGroupItemModel[]
  flexMilestonesGroup: any[]
  isMismatchECD: boolean
  isAdhocSyncing: boolean | null
}

export const multipleTemplateKey = 'flexProjectTemplateName'
const wbsKey = 1000
const uniqueGroup = (groupIndex: number): number => {
  return groupIndex * wbsKey
}
export const convertToUniqueWBS = (groupIndex: number, index: number): number => {
  //2000 + 1 = 2001
  return uniqueGroup(groupIndex) + index
}
export const convertForDisplayWBS = (groupIndex: number, wbs: number): number => {
  //2000 - 2001 = 1
  return wbs - uniqueGroup(groupIndex)
}
